import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import dompurify from 'isomorphic-dompurify';
import PropTypes from 'prop-types';
import React from 'react';
import * as infoDeroulanteStyles from '../../../styles/admissions/admissions.module.scss';
import { dompurifyConfig } from '../../../utils/utils';
import Encadre from './Encadre';

const InformationDeroulante = ({ title, titleBalise, content }) => {
  const [clicked, setClicked] = React.useState(false);
  const sanitizer = dompurify.sanitize;
  /* eslint-disable */
  const RawHtml = ({ children = '', tag: Tag = 'div', ...props }) => (
    <Tag {...props} dangerouslySetInnerHTML={{ __html: children }} />
  );
  /* eslint-enable */
  return (
    <>
      <div
        className={clsx(infoDeroulanteStyles.rootInfoDeroulante, {
          [infoDeroulanteStyles.infoDeroulanteClicked]: clicked,
          [infoDeroulanteStyles.infoDeroulanteNotClicked]: !clicked,
        })}
      >
        <button onClick={() => setClicked(!clicked)} style={{ width: '100%' }}>
          <div className={infoDeroulanteStyles.titleListDeroulante}>
            <RawHtml className={infoDeroulanteStyles.infoDeroulanteTitle} tag={titleBalise}>
              {title}
            </RawHtml>
            {clicked ? (
              <FontAwesomeIcon className="pointer" icon={faMinusCircle} size="lg"></FontAwesomeIcon>
            ) : (
              <FontAwesomeIcon className="pointer" icon={faPlusCircle} size="lg"></FontAwesomeIcon>
            )}
          </div>
        </button>
      </div>
      <div
        className={clsx(infoDeroulanteStyles.contentListDeroulante, {
          [infoDeroulanteStyles.contentListHidden]: !clicked,
        })}
      >
        <Encadre>
          <div
            className="ckContent"
            dangerouslySetInnerHTML={{
              __html: sanitizer(content, dompurifyConfig),
            }}
          ></div>
        </Encadre>
      </div>
    </>
  );
};

InformationDeroulante.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleBalise: PropTypes.string,
};

export default InformationDeroulante;
